import React, {lazy, Suspense} from 'react';
import { unstable_HistoryRouter as HistoryRouter, Route, Routes } from 'react-router-dom';
import PrivateRoute from 'routes/PrivateRoute';
import routes from 'routes/mapping-url';
import Loader from 'components/Loader';
import { history } from 'routes/history';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
   
const NotFound = lazy(() => import ('./pages/Errors/404'));

const App = () => {
  return (
    <HistoryRouter history={history}>
      <Routes>
        {routes.map(({path, name, auth, Component}, key) => {
          return auth ? (
            <Route
              key={key}
              exact
              path={path}
              element={<PrivateRoute />}
            >
              <Route path="" element={
                <Suspense fallback={<Loader show={true} />}>
                  <Component />
                </Suspense>
              } />
            </Route>
          ):(
            <Route
              key={key}
              exact
              path={path}
              element={<Suspense fallback={<Loader show={true} />}>
                <Component />
              </Suspense>}
            />
          );
        }
        )}
        <Route path="*" element={
          <Suspense fallback={<Loader show={true} />}>
            <NotFound />
          </Suspense>}/>
      </Routes>
      <ToastContainer 
        position="top-center"
        hideProgressBar
        pauseOnFocusLoss={false}
      />
    </HistoryRouter>
  );
};

export default App;
